<mat-paginator
  #paginator
  [length]="totalItems"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [pageSizeOptions]="pageSizeOptions"
  (page)="onPageChange($event)"
/>
